import React, {useContext, useEffect, useState, useRef} from "react";
import UserContext from "../../context/UserContext";
import {Link, useLocation} from "react-router-dom";
import axiosInstance from "../../config/axiosInstance";
import NotificationIcon from "./NotificationIcon";
import { useTheme } from "../../context/ThemeContext";

import { HiMenu } from "react-icons/hi";
import { HiMoon, HiSun } from "react-icons/hi";


export default function Header({ toggleSidebar}){
    const { user, logout, getUserData } = useContext(UserContext)
    const { theme, toggleTheme } = useTheme();
    const [isProfileMenuVisible, setProfileMenuVisibility] = useState(false);
    const [notifications, setNotifications] = useState("");
    const [notificationCount, setNotificationCount] = useState(false);

    const userDetails = {
        firstname: user ? user.firstname : '',
        user: user? user : null,
        lastname: user? user.lastname : ''
    }

    useEffect(() => {
        getUserData();
    }, [])

    const getNotifications = async () => {
        try{
            const response = await axiosInstance.get('/notifications');
            setNotifications(response.data.data)
            console.log(response.data.data);
            setNotificationCount(response.data.data.length);
        } catch(error){
            console.log(error);
        }
    }

    // useEffect(() => {
    //     getNotifications();
    //     const intervalId = setInterval(() => {
    //         getNotifications();
    //     }, 3000);

    //     // Cleanup the interval if the component unmounts
    //     return () => clearInterval(intervalId);
    // }, [])

    const profileMenuRef = useRef();

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (profileMenuRef.current && !profileMenuRef.current.contains(event.target)) {
                closeProfileMenu();
            }
        };
        document.addEventListener("click", handleClickOutside);

        return () => {
            document.removeEventListener("click", handleClickOutside);
        };
    }, []);

    const showProfileMenu = () => {
        setProfileMenuVisibility(!isProfileMenuVisible);
    };

    const closeProfileMenu = () => {
        setProfileMenuVisibility(false);
    };



    return(
        <>
        <header className='sticky top-0 z-30 bg-white/70 dark:bg-gray-900/70 backdrop-blur supports-[backdrop-filter]:bg-white/60 dark:supports-[backdrop-filter]:bg-gray-900/60 flex justify-between items-center px-5 py-2 border-b border-gray-200 dark:border-gray-700 w-full'>
            <div className="flex items-center gap-3">
                <button
                    onClick={toggleSidebar}
                    className="text-gray-600 dark:text-gray-300 text-2xl focus:outline-none lg:hidden"
                >
                    <HiMenu />
                </button>
                {/* <div className="hidden md:block">
                    <input
                        placeholder="Search..."
                        className="h-9 w-64 rounded-md border border-gray-200 bg-white px-3 text-sm placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-gray-200"
                    />
                </div> */}
            </div>
            <div className="flex items-center gap-2">
                <button
                    onClick={toggleTheme}
                    className="relative p-2 text-gray-600 dark:text-gray-300 hover:text-gray-900 dark:hover:text-white hover:bg-gray-100 dark:hover:bg-gray-800 rounded-lg transition-colors duration-200"
                    aria-label="Toggle dark mode"
                >
                    {theme === 'dark' ? (
                        <HiSun className="h-5 w-5" />
                    ) : (
                        <HiMoon className="h-5 w-5" />
                    )}
                </button>
                <div><NotificationIcon notificationCount={notificationCount} getNotifications={getNotifications} notifications={notifications} /></div>
                <div className="relative" ref={profileMenuRef}>
                    <button className="flex items-center gap-2 rounded-md border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 px-3 py-2 text-sm text-gray-700 dark:text-gray-200 hover:bg-gray-50 dark:hover:bg-gray-700"
                            onClick={showProfileMenu}>
                        <span className="hidden sm:inline">Hi {userDetails.firstname}</span>
                        <svg className="h-4 w-4 text-gray-500 dark:text-gray-400" viewBox="0 0 20 20" fill="currentColor"><path fillRule="evenodd" d="M5.23 7.21a.75.75 0 011.06.02L10 10.94l3.71-3.71a.75.75 0 111.06 1.06l-4.24 4.25a.75.75 0 01-1.06 0L5.25 8.27a.75.75 0 01-.02-1.06z" clipRule="evenodd" /></svg>
                    </button>

                    <div className={`${
                        isProfileMenuVisible ? 'absolute' : 'hidden'
                    } right-0 z-10 mt-2 w-56 rounded-md border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 shadow-lg`}>
                        <div className="p-2">
                            <a href="/manage/profile/settings"
                               className="block rounded-md px-3 py-2 text-sm text-gray-700 dark:text-gray-200 hover:bg-gray-50 dark:hover:bg-gray-700"
                               role="menuitem">
                                Settings
                            </a>
                            <a href="#" onClick={logout}
                               className="block rounded-md px-3 py-2 text-sm text-gray-700 dark:text-gray-200 hover:bg-gray-50 dark:hover:bg-gray-700"
                               role="menuitem">
                                Sign Out
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </header>
        </>
    )
}